import { SVGProps } from 'react';

export default function ProductTagIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="29" height="28" viewBox="0 0 29 28" fill="none">
      <g clipPath="url(#clip0_7668_17725)">
        <path
          d="M27.188 7.74697V13.0266C27.188 13.5862 26.9745 14.1459 26.5475 14.5729L14.8547 26.2657C14.0007 27.1197 12.616 27.1197 11.762 26.2657L2.4839 16.9876C1.62988 16.1336 1.62988 14.7489 2.4839 13.8949L14.1767 2.20206C14.6037 1.77507 15.1634 1.56152 15.723 1.56152H21.9084C22.4681 1.56152 23.0278 1.77502 23.4548 2.20206L25.0011 3.74839M14.8547 13.8949L16.401 12.3486"
          stroke="black"
          strokeWidth="1.64"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M27.6565 1.09326L21.5331 7.2166M19.987 5.67038L23.0793 8.76277M14.8547 20.0805C14.0006 20.9345 12.616 20.9345 11.7619 20.0805L8.66921 16.9877C7.81518 16.1337 7.81518 14.749 8.66921 13.895L11.7619 10.8023C12.616 9.94827 14.0006 9.94827 14.8547 10.8023L17.9474 13.895C18.8014 14.749 18.8014 16.1337 17.9474 16.9877L14.8547 20.0805Z"
          stroke="black"
          strokeWidth="1.64"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_7668_17725">
          <rect width="28" height="28" fill="white" transform="translate(0.75)" />
        </clipPath>
      </defs>
    </svg>
  );
}
